import { httpClient } from '@/lib/http-client'

export const projectInitiativesApi = {
    getMaturityLevels: () => httpClient.get('/project-initiatives/maturity-levels'),
    getInitiatives: (params: any) => httpClient.get('/project-initiatives/initiatives', { params }),
    getInitiative: (id: string) => httpClient.get(`/project-initiatives/${id}`),
    getRoadmap: (currentLevel: number, targetLevel: number) =>
        httpClient.get('/project-initiatives/roadmap', {
            params: { current_level: currentLevel, target_level: targetLevel },
        }),
    search: (searchTerm: string, currentLevel: number, targetLevel?: number) =>
        httpClient.get('/project-initiatives/search', {
            params: { q: searchTerm, current_level: currentLevel, target_level: targetLevel },
        }),
    // Admin — Project Initiatives
    adminInitiatives: {
        getAll: (params?: any) => httpClient.get('/project-initiatives', { params }),
        create: (data: any) => httpClient.post('/project-initiatives', data),
        update: (id: string, data: any) => httpClient.put(`/project-initiatives/${id}`, data),
        delete: (id: string) => httpClient.delete(`/project-initiatives/${id}`),
        getDomains: () => httpClient.get('/project-initiatives/domains'),
        getPriorities: () => httpClient.get('/project-initiatives/priorities'),
        importData: (form: FormData) =>
            httpClient.post('/project-initiatives/import', form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }),
        exportUrl: (format: string) => `/api/project-initiatives/export?format=${format}`,
    },
}
